<template>
  <div class="custom-wrapper" :class="{active: visible || visible2 || visible3}">
    <!-- .custom-title-type-1 === ctt1 -->
    <popper :show-popper="visible" @close="visible=false" placement="right-start" :index="index">
      <div class="ctt1" @click.prevent="setVisible()">
        <div class="ctt1-box custom-item">
          <!-- 内容 -->
          <div
            v-if="!titleModal.content"
            style="background:#91c0ec;color:#fff;text-align:center;padding:10px;"
          >点击编辑【标题】</div>
          <div
            v-else
            :style="{'color':titleModal.color,'font-size':titleModal.fontSize,'text-align':titleModal.position,'padding':titleModal.padding,'width':'100%','word-wrap':'break-word','word-break':'normal',}"
          >{{titleModal.content}}</div>

          <!-- 关闭按钮 -->
          <i class="icon iconfont icon-close-c custom-close" @click="close()"></i>
        </div>
      </div>
      <div slot="content" class="ctt1-poptip">
        <div class="ctt1p-title">标题设置</div>

        <!-- 设置内容 -->
        <div class="ctt1p-content">
          <Form ref="formInline" :label-width="100" style="width:100%;" :rules="ruleInline">
            <FormItem label="标题名称:">
              <Input v-model="titleModal.content" placeholder="请输入标题名称" />
            </FormItem>
            <FormItem label="字体大小:">
              <RadioGroup v-model="formInline.fontsize" type="button" @on-change="changefontSize">
                <Radio label="大"></Radio>
                <Radio label="中"></Radio>
                <Radio label="小"></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="文本颜色:"> 
              <ColorPicker v-model="titleModal.color" />
              <Button style="margin-left:20px;" @click="titleModal.color = '#000'">重置</Button>
            </FormItem>
            <FormItem label="边距:">
              <InputNumber :max="15" :min="0" v-model="formInline.padding" @input="changePadding"></InputNumber>
              <span style="padding-left: 5px;display: inline-block;">px</span>
            </FormItem>
            <FormItem label="显示位置:">
              <RadioGroup
                v-model="formInline.positionValue"
                type="button"
                @on-change="changePosition"
              >
                <Radio label="居左显示"></Radio>
                <Radio label="居中显示"></Radio>
                <Radio label="居右显示"></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="链接到:">
              <Tag v-if="tag" closable @on-close="TagClose">{{tag}}</Tag>
              <Dropdown trigger="click" placement="bottom-start" @on-click="selectLink">
                <a href="javascript:void(0)">
                  选择跳转到的页面
                  <Icon type="ios-arrow-down"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem name="0">自定义</DropdownItem>
                  <DropdownItem name="1">公司</DropdownItem>
                  <Dropdown placement="right-start" v-if="false">
                    <DropdownItem name="2">
                      产品分组
                      <Icon type="ios-arrow-forward"></Icon>
                    </DropdownItem>
                    <DropdownMenu slot="list">
                      <DropdownItem
                        style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
                        v-for="(item,index) of proGroupList"
                        :key="'proGroup' + index"
                        @click.native="selectProGroup(item)"
                      >{{item.name}}</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <Dropdown placement="right-start">
                    <DropdownItem name="3">
                      产品
                      <Icon type="ios-arrow-forward"></Icon>
                    </DropdownItem>
                    <DropdownMenu slot="list">
                      <DropdownItem
                        style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
                        v-for="(item,index) of proList"
                        :key="'pro' + index"
                        @click.native="selectPro(item)"
                      >{{item.name}}</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <Dropdown placement="right-start">
                    <DropdownItem name="4">
                      品牌
                      <Icon type="ios-arrow-forward"></Icon>
                    </DropdownItem>
                    <DropdownMenu slot="list">
                      <DropdownItem
                        style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"
                        v-for="(item,index) of brandList"
                        :key="'brand' + index"
                        @click.native="selectBrand(item)"
                      >{{item.name}}</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <DropdownItem name="5">商机</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </FormItem>
            <FormItem label="链接地址:" prop="link" v-show="titleModal.link.type === '0'">
              <Input @input="submitLink()" v-model="formInline.link" placeholder="请输入链接地址" />
            </FormItem>
          </Form>
        </div>
      </div>
      <!-- 
      <iModal v-model="linkModal" title="自定义链接" @on-cancel="cancelLink()" :z-index="1100">
        <Form ref="formInline" :model="formInline" :rules="ruleInline" :label-width="100">
          <FormItem label="链接地址：" prop="link">
            <Input v-model="formInline.link" placeholder="请输入链接地址" />
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="linkModal=false">取消</Button>
          <Button type="primary" @click="setLink">确定</Button>
        </div>
      </iModal>-->
    </popper>
    <!-- 上方增加键 -->
    <Poptip v-model="visible2" placement="right-start" width="411" class="custom-add-wrapper z-top">
      <img src="@/assets/img/custom/add.png" />
      <div slot="content" class="ctt1-poptip">
        <div class="ct-components">
          <div class="ctc-title">新增组件</div>
          <div class="ctc-group" v-if="commmonType===1">
            <div
              class="ctc-item"
              v-for="(item, index) in commmonArr"
              :key="'commmon-' + index"
              @click="add(item, 'top')"
            >
              <i class="icon iconfont" :class="item.icon"></i>
              <div class="ctc-item-txt">{{item.title}}</div>
            </div>
          </div>
          <div class="ctc-group" v-if="commmonType===2">
            <div
              class="ctc-item"
              v-for="(item, index) in commmonArr2"
              :key="'commmon-' + index"
              @click="add(item, 'top')"
            >
              <i class="icon iconfont" :class="item.icon"></i>
              <div class="ctc-item-txt">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </Poptip>
    <!-- 下方增加键 -->
    <Poptip
      v-model="visible3"
      placement="right-start"
      width="411"
      class="custom-add-wrapper z-bottom"
    >
      <img src="@/assets/img/custom/add.png" />
      <div slot="content" class="ctt1-poptip">
        <div class="ct-components">
          <div class="ctc-title">新增组件</div>
          <div class="ctc-group" v-if="commmonType===1">
            <div
              class="ctc-item"
              v-for="(item, index) in commmonArr"
              :key="'commmon-' + index"
              @click="add(item, 'bottom')"
            >
              <i class="icon iconfont" :class="item.icon"></i>
              <div class="ctc-item-txt">{{item.title}}</div>
            </div>
          </div>
          <div class="ctc-group" v-if="commmonType===2">
            <div
              class="ctc-item"
              v-for="(item, index) in commmonArr2"
              :key="'commmon-' + index"
              @click="add(item, 'bottom')"
            >
              <i class="icon iconfont" :class="item.icon"></i>
              <div class="ctc-item-txt">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </Poptip>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import popper from "@components/vue-popper/VuePopper.vue";
export default {
  // 标题类型 1
  name: "custom-text-type-1",
  model: {
    prop: "titleModal",
    event: "sendTitleModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    info: {
      type: Object,
      default: {
        type: 1, // 文本类型 暂时只有 1
        content: "", // 文本内容
        fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
        color: "#000", // 文字颜色 默认黑色
        position: "left" // 文本对齐格式
      }
    },
    titleModal: {
      type: Object,
      default: function() {
        return {
          type: 1, // 标题类型 暂时只有 1
          content: "文本内容",
          position: "left", // 文本对齐格式
          padding: "3px", // 标题的边距
          fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
          color: "#000", // 文字颜色 默认黑色
          link: {
            type: 0,
            value: ""
          }
        };
      }
    },
    commmonType: {
      // 通用添加组件的列表   1：所有列表   2：筛选列表
      type: Number,
      default: 1
    }
  },
  data() {
    const that = this;
    const urlReg = (rule, value, callback) => {
      if (value !== false) {
        if (!that.formInline.link) {
          callback("外链地址不能为空");
        }
        if (/(https):\/\/([\w.]+\/?)\S*/.test(that.formInline.link)) {
          callback();
        } else {
          callback("请输入正确的外链地址");
        }
      } else {
        callback();
      }
    };
    return {
      visible: false,
      visible2: false,
      visible3: false,

      commmonArr: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "标题",
          icon: "icon-biaoti",
          type: "title",
          componentName: "customTitle",
          config: {
            type: 1, // 标题类型 暂时只有 1
            content: "",
            position: "left", // 文本对齐格式
            padding: "12px", // 标题的边距
            fontSize: "12px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色
            link: {
              type: "3",
              value: ""
            }
          }
        },
        {
          title: "链接",
          icon: "icon-link",
          type: "link",
          componentName: "customLink",
          config: [{
            type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
            name: "",
            url: ""
          }]
        },
        {
          title: "产品搜索",
          icon: "icon-sousuo",
          type: "search",
          componentName: "customSearch",
          config: {
            type: 1, // 搜索类型 暂时只有 1
            words: ["热词1", "热词2"],
            style: "circular", // 搜索外边框样式 （圆 \ 方）
            position: "left", // 文本对齐格式
            color: "#ccc",
            background: "#f5f5f5",
            borderColor: "#91c0ec"
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ],
      commmonArr2: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ],

      formInline: {
        // content: "",
        fontsize: "大",
        // fontSize: "16px",
        // color: "#000",
        padding: 3,
        positionValue: "居左显示",
        // position: "left",
        // linktype: "0",
        // linkValue: ""
        link: ""
      },
      ruleInline: {
        link: [{ validator: urlReg, trigger: "blur" }]
      },
      tag: "",
      linkModal: false,
      proList: null,
      brandList: null,
      proGroupList: null
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      if (val !== this.index) this.visible = false;
    },
    titleModal: {
      handler(val, oldVal) {
        if (val.link.type === "") {
          val.link.value = "";
        }
      },
      deep: true
    }
  },
  components: {
    popper
  },
  computed: {
    ...mapGetters({
      activeIndex: "customComponentModule/getActiveIndex",
      company: "loginModule/getCompany"
    }),
    type() {
      return this.info.type;
    }
  },
  created() {
    if (this.index === this.activeIndex) {
      this.visible = true;
    }
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customComponentModule/setActiveIndex"
    }),
    ...mapActions({
      getProduct: "productModule/getProduct",
      getBrand: "companyModule/getBrand",
      getProductGroup: "productModule/getProductGroup"
    }),
    async setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    add(item, index) {
      // top 表示在上面添加  bottom表示下面添加
      let idx = this.index;
      if (index === "bottom") {
        idx = this.index + 1;
      }
      this.$emit("add", item, idx);
      this.visible = false;
      this.visible2 = false;
      this.visible3 = false;
      
      
    },
    close() {
      this.$emit("close");
    },
    changefontSize(value) {
      if (value === "大") {
        this.titleModal.fontSize = "16px";
      }
      if (value === "中") {
        this.titleModal.fontSize = "14px";
      }
      if (value === "小") {
        this.titleModal.fontSize = "12px";
      }
    },
    changePosition(value) {
      if (value === "居左显示") {
        this.titleModal.position = "left";
      }
      if (value === "居中显示") {
        this.titleModal.position = "center";
      }
      if (value === "居右显示") {
        this.titleModal.position = "right";
      }
    },
    selectLink(value) {
      switch (value) {
        case "1":
          this.tag = "公司";
          this.titleModal.link.type = "1";
          this.titleModal.link.value = "";
          break;
        case "2":
          // this.tag = "产品分组";
          // this.titleModal.link.type = "2";
          // this.formInline.link = "";
          break;
        case "3":
          // this.tag = "产品";
          // this.titleModal.link.type = "3";
          // this.formInline.link = "";
          break;
        case "4":
          // this.tag = "品牌";
          // this.titleModal.link.type = "4";
          // this.formInline.link = "";
          break;
        case "5":
          this.tag = "商机";
          this.titleModal.link.type = "5";
          this.titleModal.link.value = "";
          break;
        case "0":
          this.tag = "自定义";
          this.titleModal.link.type = "0";
          this.linkModal = true;
          break;
      }
    },
    TagClose() {
      this.tag = "";
      this.titleModal.link.type = "";
    },
    changePadding() {
      this.titleModal.padding = this.formInline.padding + "px";
    },
    async init() {
      // 产品列表
      let proList = await this.getProduct({ CompId: this.company.id });
      let proList2 = await this.getProduct({
        CompId: this.company.id,
        pageSize: proList.totalCount
      });
      this.proList = proList.items;
      // 品牌列表
      let brandList = await this.getBrand({ CompId: this.company.id });
      let brandList2 = await this.getBrand({
        CompId: this.company.id,
        pageSize: brandList.totalCount
      });
      this.brandList = brandList2.items;
      // 产品分组列表
      let proGroupList = await this.getProductGroup({
        CompId: this.company.id
      });
      let proGroupList2 = await this.getProductGroup({
        CompId: this.company.id,
        pageSize: proGroupList.totalCount
      });
      this.proGroupList = proGroupList2.items;

      if (this.titleModal && this.titleModal.fontSize) {
        switch (this.titleModal.fontSize) {
          case "16px":
            this.formInline.fontsize = "大";
          case "14px":
            this.formInline.fontsize = "中";
          case "12px":
            this.formInline.fontsize = "小";
        }
      }
      if (this.titleModal && this.titleModal.padding) {
        this.formInline.padding = parseInt(this.titleModal.padding);
      }
      if (this.titleModal && this.titleModal.position) {
        switch (this.titleModal.position) {
          case "left":
            this.formInline.positionValue = "居左显示";
          case "center":
            this.formInline.positionValue = "居中显示";
          case "right":
            this.formInline.positionValue = "居右显示";
        }
      }
      if (this.titleModal && this.titleModal.link.type) {
        switch (this.titleModal.link.type) {
          case "1":
            this.tag = "公司";
            break;
          // case "2":
          //   this.tag = "产品分组";
          //   break;
          // case "3":
          //   this.tag = "产品";
          //   break;
          // case "4":
          //   this.tag = "品牌";
          //   break;
          case "5":
            this.tag = "商机";
            break;
          case "0":
            this.tag = "自定义";
            if (this.titleModal.link.value) {
              this.formInline.link = this.titleModal.link.value;
            }
            break;
        }
        if (this.titleModal.link.type === "2" && this.titleModal.link.value) {
          this.proGroupList.map(c => {
            if (c.id === this.titleModal.link.value) {
              this.tag = `产品分组 | ${c.name}`;
            }
          });
        }
        if (this.titleModal.link.type === "3" && this.titleModal.link.value) {
          this.proList.map(c => {
            if (c.id === this.titleModal.link.value) {
              this.tag = `产品 | ${c.name}`;
            }
          });
        }
        if (this.titleModal.link.type === "4" && this.titleModal.link.value) {
          this.brandList.map(c => {
            if (c.id === this.titleModal.link.value) {
              this.tag = `品牌 | ${c.name}`;
            }
          });
        }
      }
    },
    async setLink() {
      let valid = await this.validForm("formInline");
      if (!valid) return;
      this.titleModal.link.value = this.formInline.link;
      this.linkModal = false;
    },
    cancelLink() {
      this.linkModal = false;
      this.formInline.link = "";
    },
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async submitLink() {
      let valid = await this.validForm("formInline");
      if (!valid) return;
      this.titleModal.link.value = this.formInline.link;
    },
    selectPro(item) {
      this.tag = `产品 | ${item.name}`;
      this.titleModal.link.type = "3";
      this.titleModal.link.value = item.id;
    },
    selectBrand(item) {
      this.tag = `品牌 | ${item.name}`;
      this.titleModal.link.type = "4";
      this.titleModal.link.value = item.id;
    },
    selectProGroup(item) {
      this.tag = `产品分组 | ${item.name}`;
      this.titleModal.link.type = "2";
      this.titleModal.link.value = item.id;
    }
  },
  mounted() {
    this.init();
    if (this.index === 0) {
      this.visible = true;
      this.setActiveIndex(this.index);
    }
  }
};
</script>

<style scoped lang="scss">
.ctt1 {
  width: 100%;
  // padding: 10px 10px 0;
  &-box {
    background-color: #fff;
    padding: 10px;
    cursor: pointer;
  }
  &-poptip {
    min-height: 60px;
    .ctt1p {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-content {
        padding: 20px 20px;
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
</style>
